module.exports = __webpack_public_path__ + "img/business.79f54160.jpg";